export default function mapChildrenToTranslationKeys(children) {
    if (Array.isArray(children)) {
        return children.join('');
    }
    return children.toString();
}
//# sourceMappingURL=map-children-to-translation-key.js.map